// extracted by mini-css-extract-plugin
module.exports = {"modal":"UpdateImageModal_modal__FwlTm","title":"UpdateImageModal_title__RHZ4Q","buttonHolder":"UpdateImageModal_buttonHolder__3nHPE"};